import * as Blockly from 'blockly/core';
import { blockFor } from '@/(routers)/boards/editor/block/generators/arduino/_gen';
import { variableDeclarations } from '@/(routers)/boards/editor/block/generators/arduino/blocks/variable/variable';

export function register(gen: any): void {
    gen.forBlock['for_var'] = function (block: Blockly.Block): string {
        const varName = block.getFieldValue('VAR_LABEL') as string;
        if (!varName || varName === '設定する変数') return '';
        const from = gen.valueToCode(block, 'FROM', 0) || '0';
        const to = gen.valueToCode(block, 'TO', 0) || '0';
        const step = gen.valueToCode(block, 'STEP', 0) || '1';
        const direction = block.getFieldValue('DIRECTION') as string;
        const condition = direction === 'decrement' ? '>=' : '<=';
        const operator =
            step === '1' ? (direction === 'decrement' ? '--' : '++') : direction === 'decrement' ? '-=' : '+=';
        const update = step === '1' ? `${varName}${operator}` : `${varName} ${operator} ${step}`;

        const body = gen.statementToCode(block, 'DO');
        variableDeclarations.delete(varName);
        return blockFor(`int ${varName} = ${from}`, `${varName} ${condition} ${to}`, update, body);
    };
}
